export default "__VITE_ASSET__hlICN$kY__"